module.exports = __webpack_public_path__ + "img/img22s.7ad3409c.png";